import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Dropdown,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDivisionScheduleUX = (props: any) => {
    return(
      <div
        id="CardDivisionScheduleUX-div-0"
        style={{display: "flex", height: "94vh"}}>
        <div
          id="CardDivisionScheduleUX-div-1"
          style={{flex: 1, padding: "5px"}}>

          <div
            id="CardDivisionScheduleUX-div-15"
            style={{display: "flex", alignItems: "center", marginBottom: "0.75rem"}}>

            <label
              id="CardDivisionScheduleUX-label-16"
              style={{marginRight: "0.5rem"}}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </label>
            <Dropdown
              className="size small"
              fluid={true}
              id="CardDivisionScheduleUX-Dropdown-17"
              loading={props.isDivisionLoading ?? false}
              onChange={props.onChangeDivision}
              options={props.divisionOptions}
              placeholder="Please select the division"
              search={true}
              selectOnBlur={true}
              selection={true}
              style={{marginRight: "0.5rem"}}
              value={props.selectedDivisionId??""}>
            </Dropdown>
          </div>
          <div
            style={{display: props.showSlotLength?"flex":"none", alignItems: "center", marginBottom: "0.75rem"}}>

            <label
              style={{minWidth: "max-content", marginRight: "1rem"}}>
              {props.languageUX === "en" ? "Service time per patient (minutes)" : "เวลาให้บริการต่อคนไข้ (นาที)"}
            </label>
            <Input
              disabled={props.disabledSlotLength}
              fluid={true}
              onChange={props.onChangeSlotLength}
              style={{width: "100%", marginRight: "0.5rem"}}
              value={props.slotLength}>
            </Input>
          </div>
          <div
            id="CardDivisionScheduleUX-div-4"
            style={{display: "flex", alignItems: "center"}}>

            <div
              id="CardDivisionScheduleUX-div-5"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Created List" : "รายการที่สร้างแล้ว"}
            </div>
            <div
              id="CardDivisionScheduleUX-div-7"
              style={{flex: 1}}>

            </div>
          </div>
          <Table
            data={props.scheduleTemplates}
            getTrProps={props.templateRowProps}
            headers="ตั้งแต่,ถึง,วันที่เปิด"
            id="CardDivisionScheduleUX-Table-3"
            keys="start,end,days"
            showPagination={false}
            style={{height: "calc(-8rem + 100vh)"}}>
          </Table>
        </div>
        <div
          id="CardDivisionScheduleUX-div-2"
          style={{flex: 3, padding: "5px", display: "flex", flexDirection: "column", overflowY: "auto"}}>

          <div
            id="CardDivisionScheduleUX-div-8"
            style={{display: "flex", alignItems: "center"}}>

            <div
              id="CardDivisionScheduleUX-div-10"
              style={{margin: "0 10px 0 0"}}>
              {props.languageUX === "en" ? "Since the date" : "ตั้งแต่วันที่"}
            </div>
            <DateTextBox
              disabled={props.editMode}
              id="CardDivisionScheduleUX-DateTextBox-11"
              onChange={props.changeDate("startDateTime")}
              value={props.startDateTime}>
            </DateTextBox>
            <div
              id="CardDivisionScheduleUX-div-12"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Until the date" : "ถึงวันที่"}
            </div>
            <DateTextBox
              disabled={props.editMode}
              id="CardDivisionScheduleUX-DateTextBox-13"
              onChange={props.changeDate("endDateTime")}
              value={props.endDateTime}>
            </DateTextBox>
            <Button
              color="blue"
              disabled={!props.selectedDivisionId}
              id="CardDivisionScheduleUX-Button-6"
              onClick={props.onClear}
              size="small"
              style={{margin: "0 10px 0 10px", display: props.showSlotLength?"none":""}}>
              {props.languageUX === "en" ? "Clear (Create a new item)" : "เคลียร์ (สร้างรายการใหม่)"}
            </Button>
            <Button
              color="green"
              disabled={props.onLoading || !props.selectedDivisionId}
              id="CardDivisionScheduleUX-Button-14"
              loading={props.onLoading}
              onClick={props.onSave}
              size="small"
              style={{margin: "0 10px 0 10px", display: props.showSlotLength?"none":""}}>
              {props.languageUX === "en" ? "Update (SAVE)" : "อัพเดท (SAVE)"}
            </Button>
          </div>
          <div
            style={{display: props.showSlotLength?"flex":"none", alignItems: "center", marginTop: "0.75rem"}}>
            {}
            <Button
              color="blue"
              disabled={!props.selectedDivisionId}
              onClick={props.onClear}
              size="small"
              style={{margin: "0 10px 0 0"}}>
              {props.languageUX === "en" ? "Clear (Create a new item)" : "เคลียร์ (สร้างรายการใหม่)"}
            </Button>
            <Button
              color="green"
              disabled={props.onLoading || !props.selectedDivisionId || !props.slotLength}
              loading={props.onLoading}
              onClick={props.onSave}
              size="small"
              style={{margin: "0 10px 0 10px"}}>
              {props.languageUX === "en" ? "Update (SAVE)" : "อัพเดท (SAVE)"}
            </Button>
          </div>
          <div
            id="CardDivisionScheduleUX-div-9"
            style={{display: "flex", flex: 1,  marginTop: "10px"}}>
            {props.weekTemplate}
          </div>
        </div>
      </div>
    )
}

CardDivisionScheduleUX.displayName = "CardDivisionScheduleUX";
export default React.memo(CardDivisionScheduleUX)

export const screenPropsDefault = {}

/* Date Time : Mon Oct 06 2025 11:14:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", height: \"94vh\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1, padding: \"5px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, padding: \"5px\", display: \"flex\", flexDirection: \"column\", overflowY: \"auto\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 1,
      "props": {
        "data": {
          "type": "code",
          "value": "props.scheduleTemplates"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.templateRowProps"
        },
        "headers": {
          "type": "value",
          "value": "ตั้งแต่,ถึง,วันที่เปิด"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-Table-3"
        },
        "keys": {
          "type": "value",
          "value": "start,end,days"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(-8rem + 100vh)\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการที่สร้างแล้ว",
          "valueEN": "Created List"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์ (สร้างรายการใหม่)",
          "valueEN": "Clear (Create a new item)"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\", display: props.showSlotLength?\"none\":\"\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.weekTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flex: 1,  marginTop: \"10px\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งแต่วันที่",
          "valueEN": "Since the date"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 0\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 11,
      "name": "DateTextBox",
      "parent": 8,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.editMode"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-DateTextBox-11"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"startDateTime\")"
        },
        "value": {
          "type": "code",
          "value": "props.startDateTime"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึงวันที่",
          "valueEN": "Until the date"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 13,
      "name": "DateTextBox",
      "parent": 8,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.editMode"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-DateTextBox-13"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"endDateTime\")"
        },
        "value": {
          "type": "code",
          "value": "props.endDateTime"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "อัพเดท (SAVE)",
          "valueEN": "Update (SAVE)"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.onLoading || !props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-Button-14"
        },
        "loading": {
          "type": "code",
          "value": "props.onLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\", display: props.showSlotLength?\"none\":\"\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"0.75rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-label-16"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDivisionScheduleUX-Dropdown-17"
        },
        "loading": {
          "type": "code",
          "value": "props.isDivisionLoading ?? false"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Please select the division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId??\"\""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showSlotLength?\"flex\":\"none\", alignItems: \"center\", marginBottom: \"0.75rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลาให้บริการต่อคนไข้ (นาที)",
          "valueEN": "Service time per patient (minutes)"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", marginRight: \"1rem\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Input",
      "parent": 18,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabledSlotLength"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSlotLength"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.slotLength"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showSlotLength?\"flex\":\"none\", alignItems: \"center\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Button",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์ (สร้างรายการใหม่)",
          "valueEN": "Clear (Create a new item)"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 0\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Button",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "อัพเดท (SAVE)",
          "valueEN": "Update (SAVE)"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.onLoading || !props.selectedDivisionId || !props.slotLength"
        },
        "loading": {
          "type": "code",
          "value": "props.onLoading"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 10px 0 10px\"}"
        }
      },
      "seq": 23,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardDivisionScheduleUX",
  "project": "cudent2",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
